export default __webpack_public_path__ + "assets/images/maito-ead93ee66f24b64f260edc57d83df989.png";